import { createContext } from "react";

import EmailTemplate from "@mapmycustomers/shared/types/email/EmailTemplate";

export interface EmailsTemplatesModalContextValue {
  emailTemplatesModalOpen: boolean;
  onHideEmailTemplatesModal(): void;
  onShowEmailTemplatesModal(selectedTemplateId?: EmailTemplate["id"]): void;
}

const EmailsTemplatesModalContext = createContext<EmailsTemplatesModalContextValue | null>(null);

EmailsTemplatesModalContext.displayName = "EmailsTemplatesModalContext";

export default EmailsTemplatesModalContext;
